export const adjustColor = (hex: string, percent: number) => {
  // Hexni RGB ga aylantirish
  const hexToRgb = (hex) => {
    hex = hex.length === 4 ? hex.replace(/./g, (m) => m + m) : hex;
    return [
      parseInt(hex.slice(1, 3), 16),
      parseInt(hex.slice(3, 5), 16),
      parseInt(hex.slice(5, 7), 16)
    ];
  };

  // RGBni Hexga aylantirish
  const rgbToHex = (rgb) =>
      `#${rgb.map((val) => Math.max(0, Math.min(255, val)).toString(16).padStart(2, '0')).join('')}`;

  // Rangni o‘zgartirish
  const rgb = hexToRgb(hex);
  const adjustedRgb = rgb.map((val) => val + Math.round((val * percent) / 100));
  return rgbToHex(adjustedRgb);
}